import FootballState from "../../../../state/football-state";
import FootballStatsCategory from "../../../../stats/football-stats-category";
import StatsRule from "../../../../../common/stats-rule";

export default class KickoffReturnStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Returned &&
            play.getPreviousFragment(fragment).associatedState ===
                FootballState.KickOff &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { kickedTo } = play.getPreviousFragmentOfState(
            fragment,
            FootballState.KickOff
        );

        const yardsReturned =
            (fragment.returnedAt - kickedTo) *
            gameContext.getFieldDirectionMultiplier();
        const resultedInTd =
            (gameContext.isVisitorPossession() && fragment.returnedAt <= 0) ||
            (gameContext.isHomePossession() &&
                fragment.returnedAt >= gameContext.getFieldLength());

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.returnedBy?.teamId,
            playerId: fragment.returnedBy?.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.KICK_OFF_RETURN,
            values: {
                yards: yardsReturned,
                completed: 1,
                attempted: 1,
                touchdowns: resultedInTd ? 1 : 0
            }
        });
    }
}
